import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductService } from 'app/server/server.module';
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { ADMIN_API_SERVER_URL } from 'app/server/services/tokens/admin-api-server-url.token';

@Component({
  selector: 'app-data-access',
  templateUrl: './data-access.component.html',
  styleUrls: ['./data-access.component.scss']
})
export class DataAccessComponent implements OnInit {
  // available object types - currently only Product
  public objectTypes = ['Product'];
  public selectedType = 'Product';

  public searchTerm = '';
  public results: any[] = [];
  public resultColumns: string[] = [];
  public searchModel: any = {};
  public selectedId: number | null = null;

  // mode: 'search' | 'view' | 'edit'
  public mode: 'search' | 'view' | 'edit' = 'search';

  constructor(
    private productService: ProductService,
    private http: HttpClient,
    @Inject(ADMIN_API_SERVER_URL) private serverUrl: string
  ) {}

  ngOnInit(): void {
    // initial state: search open
    this.mode = 'search';
  }

  public doSearch() {
    this.results = [];

    // If an ID is specified, use direct lookup
    const id = Number(this.searchModel.ID ?? this.searchModel.Id ?? this.searchTerm);
    if (!isNaN(id) && id) {
      this.productService.getProduct(id);
      this.productService.product$.pipe().subscribe(p => {
        if (p) this.results = [p];
      });
      this.mode = 'search';
      return;
    }

    // Try product search API (POST) with the searchModel; fall back to OrderProcessing search if unavailable
    this.http.post<any[]>(this.serverUrl + 'Product/Search', this.searchModel || {})
      .subscribe(res => {
        this.results = res || [];
        this.setupColumns();
        this.mode = 'search';
      }, () => {
        const term = (this.searchTerm || '').trim();
        if (!term) return;
        this.http.get<any[]>(this.serverUrl + 'OrderProcessing/SearchProducts', { params: { q: term } })
          .subscribe(res => { this.results = res || []; this.setupColumns(); this.mode = 'search'; }, () => { this.results = []; this.resultColumns = []; this.mode = 'search'; });
      });
  }

  private setupColumns() {
    this.resultColumns = [];
    if (!this.results || this.results.length === 0) return;
    const first = this.results[0];
    const preferred = ['ProductID', 'ID', 'Code', 'ProductName', 'Name', 'Description', 'Supplier', 'CountryOfOrigin', 'HSCode', 'Unit', 'Price'];
    preferred.forEach(k => { if (k in first && !this.resultColumns.includes(k)) this.resultColumns.push(k); });
    // add any other keys up to a reasonable limit
    Object.keys(first).forEach(k => { if (!this.resultColumns.includes(k)) this.resultColumns.push(k); });
    // limit columns to 10 for readability
    this.resultColumns = this.resultColumns.slice(0, 10);
  }

  public headerLabel(key: string): string {
    const map: any = {
      ProductID: 'Product ID',
      ID: 'ID',
      Code: 'Code',
      ProductName: 'Name',
      Name: 'Name',
      Description: 'Description',
      Supplier: 'Supplier',
      CountryOfOrigin: 'Country',
      HSCode: 'HSCode',
      Unit: 'Unit',
      Price: 'Price'
    };
    return map[key] ?? key;
  }

  public selectResult(item: any) {
    const id = item?.ID ?? item?.ProductID ?? item?.Product?.ID ?? null;
    this.selectedId = id;
    this.mode = 'view';
  }

  public setView() { if (this.selectedId) this.mode = 'view'; }
  public setSearch() { this.mode = 'search'; }
  public setEdit() { if (this.selectedId) this.mode = 'edit'; }

  public addNew() {
    this.selectedId = null;
    this.mode = 'edit';
  }

  public updateSelected() {
    if (this.selectedType !== 'Product') return;
    // get current product from service and send to save
    this.productService.product$.subscribe(prod => {
      if (!prod) return;
      const url = this.serverUrl + 'Product/Save';
      // this.http.post(url, prod).subscribe(() => {
      //   if (prod.ID) {
      //     // refresh
      //     this.productService.getProduct(prod.ID);
      //   }
      // });
    }).unsubscribe();
  }

  public deleteSelected() {
    if (!this.selectedId) return;
    if (this.selectedType !== 'Product') return;
    const url = this.serverUrl + 'Product/Delete';
    this.http.post(url, { Id: this.selectedId }).subscribe(() => {
      this.selectedId = null;
      this.mode = 'search';
      this.results = this.results.filter(r => (r.ID ?? r.ProductID) !== this.selectedId);
    });
  }
}
